import {Component, EventEmitter, Input, Output} from "@angular/core";
import {AvdbSubscriptionService} from "../avdb-subscription.service";
import {fgURL} from "site";
import {SubscriptionResponse} from "../subscription-response";
import {flatten} from "@angular/compiler";
import {ConnextSubscriptionStatusResponse} from "../connext-subscription-status-response";
import {ConnextService} from "../connext.service";
import {Observable} from "rxjs";

enum State {
	Initial,
	CancellingDatabaseSubscriptions,
	ErrorCancellingSubscriptions
}

@Component({
	selector: "transfer-cancel-databases",
	template: `
		<h1>Cancel Database Subscriptions</h1>

		<ng-container *ngIf="currentState === State.Initial">
			In order to transfer the selected aircraft and devices, all database subscriptions must be cancelled.

			<br><br>

			Upon cancellation, the databases will no longer be installable.
			For details about what subscriptions will be cancelled, visit the subscription management center (located at 'Subscriptions > Databases > Manage Subscriptions' in the navigation bar).

			<br><br>

			<input type="checkbox" (change)="acknowledged = !acknowledged">Check here to acknowledge you have read the above and your subscriptions will be immediately cancelled for the selected aircraft and devices.
			<br><br>
			<button
				(click)="cancelSubscriptions()"
				class="button button-primary py-1 px-5"
				[disabled]="!acknowledged">
				CANCEL SUBSCRIPTIONS
			</button>
		</ng-container>

		<ng-container *ngIf="currentState === State.CancellingDatabaseSubscriptions">
			<div class="px-4 py-2">
				<div class="loading-indicator" style="text-align: center;">Cancelling Database Subscriptions...</div>
			</div>
		</ng-container>

		<ng-container *ngIf="currentState === State.ErrorCancellingSubscriptions">
			<div>
				An error occurred while cancelling the services for one or more aircraft and/or devices.
			</div>
			<br>
			<div>
				Refresh the page to try again, and if errors persist contact <a href="{{fgUrl}}aviation-support">Aviation Product Support</a>.
			</div>
		</ng-container>
	`,
})

export class TransferCancelDatabasesComponent {
	@Input() masterAircraftUuids: string[];
	@Output() subscriptionsCancelled = new EventEmitter();

	readonly State = State;
	currentState: State = State.Initial;

	acknowledged: boolean = false;
	fgUrl: string = fgURL;
	pendingCancellationUuids: string[] = [];

	constructor(private readonly avdbSubscriptionService: AvdbSubscriptionService,
				private readonly connextService: ConnextService
	) {
	}

	cancelSubscriptions(){
		this.currentState = State.CancellingDatabaseSubscriptions;
		Observable.forkJoin(
			this.masterAircraftUuids.map((masterAircraftUuid) =>
				this.avdbSubscriptionService.cancelAllSubscriptionsForAircraft(masterAircraftUuid))
		)
		.catch(() => {
			this.currentState = State.ErrorCancellingSubscriptions;
			let subscriptionResponses: Array<SubscriptionResponse>[] = []
			return Observable.of(subscriptionResponses);
		})
		.subscribe((responses: Array<SubscriptionResponse>[]) => {
				this.pendingCancellationUuids = flatten(responses).map((response) => response.jobUuid);
				this.checkCancellationStatus();
			}
		);
	}

	checkCancellationStatus() {
		if (this.pendingCancellationUuids != null && this.currentState !== State.ErrorCancellingSubscriptions) {
			Observable.forkJoin(this.pendingCancellationUuids.map((cancellationUuid) =>
				Observable.timer(0, 30000)
				.mergeMap(() => this.connextService.getActivationSubscriptionJobStatus(cancellationUuid))
				.filter((status: ConnextSubscriptionStatusResponse | null) => status != null && status.statusText === 'Complete')
				.take(1))
			).subscribe(() => this.subscriptionsCancelled.emit());
		}
	}
}
